import React from 'react'
import ErrorPage from './ErrorPage'
import Layout from '../../common/Layout'
import history from '../../core/history'

export default {

  path: '/error',

  action ({ error }) {
    // history is browser-only (undefined during SSR); guard so /error can render server-side too.
    const location = history ? history.location : null

    const appStateError = location && location.state ? location.state.error : null

    const pageTitle = 'Oops!'
    const backButtonText = 'Back'
    const unknownError = {
      name: 'Error',
      message: 'A critical error occurred.'
    }

    var displayError = unknownError

    if (error) {
      displayError = error
    }

    if (appStateError) {
      displayError = appStateError
    }
    return {
      title: displayError.name,
      description: displayError.message,
      component: <Layout pageTitle={pageTitle} backButtonText={backButtonText} containerWell><ErrorPage error={displayError} /></Layout>,
      status: displayError.status || 500
    }
  }

}
